import {
  useMetricsStats,
  useMetricsTrends,
  useMetricsDistribution,
} from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
  MetricsFilters,
} from "../../../../../shared/api/types";

export const useTeamProgressStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "day_strain",
      "respiratory_rate",
      "spo2",
      "calories_burn",
      "recovery_score",
      "sleep_performance",
      "hrv",
      "resting_heart_rate",
      "temperature",
    ],
  });
};

export const useTeamProgressTrends = (params?: Partial<MetricsTrendsParams>) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || [
      "day_strain",
      "avg_heart_rate",
      "max_heart_rate",
      "respiratory_rate",
      "spo2",
      "sleep_efficiency",
      "sleep_debt",
      "sleep_stress",
      "hrv",
      "resting_heart_rate",
      "recovery_score",
      "sleep_stage_awake",
      "sleep_stage_light",
      "sleep_stage_rem",
      "sleep_stage_deep",
      "temperature",
    ],
    granularity: params?.granularity || "daily",
  });
};

export const useWellbeingDistribution = (params?: MetricsFilters) => {
  return useMetricsDistribution({
    ...params,
    metric: "wellbeing_dimensions",
  });
};
